import { r as registerInstance, h, g as getElement } from './index-16dc7dde.js';
import './lookups-705fb53e.js';
import { j as join } from './path-9b025204.js';
import { T as TAB_NAMES, F as FILTER_STATE_CHANGED_EVENT_NAME } from './analytics-765d4daf.js';
import { r as rangeBasePath } from './request.constants-deb285e0.js';
import { Z as getRangeFilterUrl, _ as getSelectedNodeIdFromUrl, M as getCountry, O as getLanguage, $ as getLocaleWithV3, a0 as filterReset, a1 as setPaginationParams, a2 as trackFilterAnalytics, a3 as setNavigationFilterPath, a4 as getPaginationParams, a5 as fetchSprykerFilters, a6 as getPbsFilterProductsUrl, a7 as getFilterProductsUrl, g as getData, a8 as parseRichText, a as isMobile, a9 as getBaseUrl, aa as DEFAULT_NAVIGATION_STATE, ab as pageParam } from './utils-15ad90ec.js';
import { i as isEmpty_1 } from './isEmpty-b60327cb.js';
import { t as tryParse } from './parsers-e38ff6a5.js';
import { c as calculateCurrentNodeParams, a as getCurrentReference, g as getRangeNodesIds } from './range-helpers-2dd7a4ef.js';
import './_commonjsHelpers-ba3f0406.js';
import './send-33ade633.js';
import './utils-913bdf8a.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './isTypedArray-dfccd669.js';

const pesSprykerRangeTabsCss = ":host{display:block;box-sizing:border-box;--document-listing-top-margin:0;--document-listing-top-margin-mobile:0}:host *,:host *::before,:host *::after{box-sizing:inherit}.range-tabs{width:100%;height:100%}pes-document-listing .document-listing-container{background:transparent;box-sizing:border-box}pes-document-listing .document-listing-container *,pes-document-listing .document-listing-container *::before,pes-document-listing .document-listing-container *::after{box-sizing:inherit}";

let RangeTabs = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.host = '';
    this.name = 'TODO';
    this.enableCommerceConnector = true;
    this.showBuyOnline = true;
    this.isPBS = false;
    this.products = [];
    this.productsCount = 0;
    this.filtersCategories = [];
    this.isTabsInitialized = false;
    this.isMobileCategorySelected = false;
    this.isLoading = false;
    this.documentsTabEnabled = {
      [TAB_NAMES.Documents]: false,
      [TAB_NAMES.Software]: false,
    };
    this.pills = [];
    this.PBSoffset = 0;
    this.handlePopState = () => {
      var _a, _b;
      if (this.isPBS)
        return;
      const { offset, productsPerPage } = this.getPaginationParamsWithDefaults;
      this.selectedPage = Math.floor(offset / productsPerPage) + 1;
      const changedFilterUrl = getRangeFilterUrl(this.filterNodeId, (_b = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.filtersUrl, this.localeCode);
      this.nodeOrSubCatId = getSelectedNodeIdFromUrl(this.initialNodeId);
      this.loadFilters(changedFilterUrl);
    };
    this.renderPresentationTab = () => {
      var _a;
      return (((_a = this.tabs) === null || _a === void 0 ? void 0 : _a.presentation) && (h("pes-range-presentation-tab", { presentation: this.tabs.presentation })));
    };
    this.renderWebinarsAndResources = () => {
      var _a;
      return (((_a = this.tabs) === null || _a === void 0 ? void 0 : _a.webinarsAndResources) && (h("pes-range-webinars-and-resources-tab", { webinarAndResources: this.tabs.webinarsAndResources })));
    };
    this.renderProductsTab = () => (h("pes-range-products-tab", { labels: {
        commonFiltersFilterBy: this.commonFiltersFilterBy,
        facetButtonResetAllLabel: this.facetButtonResetAllLabel,
        rangeProductsFiltersLabel: this.rangeProductsFiltersLabel,
        facetButtonViewMoreFilters: this.facetButtonViewMoreFilters,
        facetButtonViewLessFilters: this.facetButtonViewLessFilters,
        previousLabel: this.previousLabel,
        nextLabel: this.nextLabel,
        labelValue: this.pageLabel,
        viewProductsLabel: this.viewProductsLabel,
        rangeProductLabel: this.rangeProductLabel,
        appProductsLabel: this.appProductsLabel,
        numberProductsOfAllProductsLabel: this.numberProductsOfAllProductsLabel,
        noResultsClearLink: this.noResultsClearLink,
        noResultsHeader: this.noResultsHeader,
        noResultsMessage: this.noResultsMessage,
        viewMoreLabel: this.viewMoreLabel,
        viewLessLabel: this.viewLessLabel,
        loadMoreLabel: this.loadMoreLabel,
        loadPreviousLabel: this.loadPreviousLabel,
      }, hostWithLocale: this.isPBS ? this.host : this.localeCode, name: this.name, currentNode: this.currentNode, filters: this.filters, filtrationSmartData: this.filtrationSmartData, navigationState: this.nodeOrSubCatId, productList: this.products.map((productInfo) => productInfo).join(), productUrlParams: this.productUrlParams || '', pills: this.pills, categories: this.filtersCategories, productsPerPage: this.getPaginationParamsWithDefaults.productsPerPage, productsCount: this.productsCount, selectedPage: this.selectedPage, isLoading: this.isLoading, isMobileCategorySelected: this.isMobileCategorySelected, showDocuments: this.showDocuments, resultCount: this.resultsCount, firstLoadedRecNum: this.firstLoadedRecNum, lastLoadedRecNum: this.lastLoadedRecNum, richText: this.richText, enableCommerceConnector: this.enableCommerceConnector, showBuyOnline: this.showBuyOnline, selectedSectionsCount: this.selectedSectionsCount, productCtas: this.productCtas, showCompare: !this.isPBS, isPBS: this.isPBS, enableAppRouting: this.isPBS, localeCode: this.localeCode }));
    this.renderDocumentListing = (name, isSoftware) => {
      var _a, _b;
      return (!isEmpty_1(this.tabs.documents) && (h("pes-document-listing", { name: name, apiEndpoint: this.tabs.documents.apiEndpoint, documentDetailsUrl: this.tabs.documents.documentDetailsUrl, enableDocumentDetailsUrl: false, country: getCountry(this.localeCode), language: getLanguage(this.localeCode), pageType: "range", resourceId: this.id, software: isSoftware, view: "smallcard", myFavorites: false, applicationSource: (_b = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.documents) === null || _b === void 0 ? void 0 : _b.appSource })));
    };
    this.renderSoftwareRegistration = () => {
      return (!isEmpty_1(this.tabs.softwareRegistration) && (h("pes-range-software-registration-tab", { url: this.tabs.softwareRegistration.softwareRegistrationUrl })));
    };
    this.getTabs = () => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      const productsTab = {
        title: (_b = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.title,
        renderFunction: this.renderProductsTab,
        hash: TAB_NAMES.Products,
        hidden: false,
        hideHash: true,
      };
      return [
        ((_d = (_c = this.tabs) === null || _c === void 0 ? void 0 : _c.products) === null || _d === void 0 ? void 0 : _d.showProductsTab) && productsTab,
        {
          title: this.rangePresentationLabel,
          renderFunction: this.renderPresentationTab,
          hash: TAB_NAMES.Presentation,
          hidden: false,
        },
        {
          title: (_f = (_e = this.tabs) === null || _e === void 0 ? void 0 : _e.documents) === null || _f === void 0 ? void 0 : _f.documentLabel,
          renderFunction: () => this.renderDocumentListing(TAB_NAMES.Documents, false),
          hash: TAB_NAMES.Documents,
          hidden: !this.documentsTabEnabled[TAB_NAMES.Documents],
        },
        {
          title: this.rangeSoftwareAndFirmwareLabel,
          renderFunction: () => this.renderDocumentListing(TAB_NAMES.Software, true),
          hash: TAB_NAMES.Software,
          hidden: !this.documentsTabEnabled[TAB_NAMES.Software],
        },
        {
          title: this.softwareRegistrationLabel,
          renderFunction: this.renderSoftwareRegistration,
          hash: TAB_NAMES.SoftwareRegistration,
          hidden: isEmpty_1((_g = this.tabs) === null || _g === void 0 ? void 0 : _g.softwareRegistration),
        },
        {
          title: this.rangeWebinarsAndResourcesLabel,
          renderFunction: this.renderWebinarsAndResources,
          hash: TAB_NAMES.WebinarAndResources,
          hidden: isEmpty_1((_h = this.tabs) === null || _h === void 0 ? void 0 : _h.webinarsAndResources),
        },
      ];
    };
  }
  documentListingReady(event) {
    const { name, hasDocuments } = event.detail;
    this.documentsTabEnabled = Object.assign(Object.assign({}, this.documentsTabEnabled), { [name]: hasDocuments });
  }
  handleNodeSelected(event) {
    var _a, _b, _c;
    const { id, nodeReference } = event.detail;
    this.PBSoffset = 0;
    this.currentNode = calculateCurrentNodeParams({
      nodeReference: this.rangeReference,
      id,
      name: this.name,
      nodes: (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products.nodes,
    }, join(getLocaleWithV3(this.localeCode, /^[^A-Z]+$/.test(this.localeCode)), rangeBasePath, this.rangeReference), nodeReference, this.backLabel);
    this.filterNodeId = this.currentNode.id;
    this.initialfilterUrl = this.getInitialFiltersUrl;
    const nodeFilterUrl = getRangeFilterUrl(this.filterNodeId, (_c = (_b = this.tabs) === null || _b === void 0 ? void 0 : _b.products) === null || _c === void 0 ? void 0 : _c.filtersUrl, this.localeCode);
    this.loadFilters(nodeFilterUrl);
  }
  onFilterStateChanged(event) {
    const { lastChangedFilterId: filterId } = event.detail;
    if (filterId) {
      const { rootSectionId, seoUrl, checkedURL, unCheckedURL, navigationState } = this.filtersNormalized.entities.filter[filterId];
      const changedFilterUrl = unCheckedURL !== '' ? unCheckedURL : checkedURL;
      const nodeIdOnFilterChange = navigationState === DEFAULT_NAVIGATION_STATE ? this.nodeOrSubCatId : navigationState;
      this.changeFilter(changedFilterUrl, nodeIdOnFilterChange, filterReset(changedFilterUrl, this.initialfilterUrl), rootSectionId === 'product.category' ? seoUrl : '');
    }
  }
  onSelectCategoryHandler(event) {
    this.setActive(event.detail);
    this.isMobileCategorySelected = true;
  }
  resetAllFiltersHandler() {
    this.isResetFilters = true;
    this.changeFilter(this.initialfilterUrl, this.initialNodeId, true, join(getLocaleWithV3(this.localeCode, /^[^A-Z]+$/.test(this.localeCode)), 'product-range', this.initialNodeIds.rangePath));
  }
  onToggleMobileViewVisibility(event) {
    const { detail } = event;
    if (detail === null || detail === void 0 ? void 0 : detail.restore) {
      this.setActive(this.navigationStateBeforeFilterMobileViewOpen);
    }
    else if (!detail) {
      this.navigationStateBeforeFilterMobileViewOpen = this.baseFilterUrl;
    }
  }
  removePillHandler(event) {
    const unCheckedURL = event.detail;
    this.changeFilter(unCheckedURL, this.nodeOrSubCatId, filterReset(unCheckedURL, this.initialfilterUrl));
  }
  productClickHandler(event) {
    var _a;
    const productRef = event.detail;
    (_a = this.onProductClick) === null || _a === void 0 ? void 0 : _a.call(this, productRef);
  }
  choosePage(event) {
    this.selectedPage = event.detail;
    const { productsPerPage } = this.getPaginationParamsWithDefaults;
    if (!this.isPBS) {
      setPaginationParams(productsPerPage * (this.selectedPage - 1), productsPerPage, true);
    }
    this.PBSoffset = productsPerPage * (this.selectedPage - 1);
    this.loadProducts(this.selectedFilterUrl);
  }
  mobileCategoryReset() {
    this.isMobileCategorySelected = false;
  }
  trackAnalyticsEventListener(e) {
    const { event } = e.detail;
    if (!event)
      return;
    if (event === FILTER_STATE_CHANGED_EVENT_NAME)
      trackFilterAnalytics(e, this.filtersNormalized);
  }
  changeFilter(changedFilterUrl, nodeId, isReset, seoUrl) {
    if (!this.isPBS) {
      setNavigationFilterPath(changedFilterUrl, nodeId, isReset, seoUrl);
    }
    this.nodeOrSubCatId = getSelectedNodeIdFromUrl(this.initialNodeId);
    this.setActive(changedFilterUrl);
  }
  get activeCategory() {
    var _a, _b;
    const category = (_a = this.filters) === null || _a === void 0 ? void 0 : _a[0];
    return category && ((_b = category.filterRefinements.find((i) => i.checked)) === null || _b === void 0 ? void 0 : _b.label);
  }
  get getPaginationParamsWithDefaults() {
    return getPaginationParams({
      offset: 0,
      productsPerPage: Number(this.tabs.products.numberProductsOnRangePage),
    });
  }
  get getInitialFiltersUrl() {
    var _a, _b, _c;
    if (!((_c = (_b = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.nodes) === null || _c === void 0 ? void 0 : _c.length))
      return this.baseFilterUrl;
    if (!this.isPBS && this.initialNodeIds.nodeId) {
      return `${this.baseFilterUrl}&hlnode-id=${this.initialNodeIds.nodeId}`;
    }
    return this.filterNodeId
      ? `${this.baseFilterUrl}&hlnode-id=${this.filterNodeId}`
      : this.baseFilterUrl;
  }
  async loadFilters(filterUrl) {
    this.isLoading = true;
    try {
      const { filtersNormalized, filtrationSmartData, pills, filtersCategories, selectedSectionsCount, filters, } = await fetchSprykerFilters(`${this.host}${filterUrl}`);
      this.filters = filters !== null && filters !== void 0 ? filters : [];
      this.filtersNormalized = filtersNormalized;
      this.filtrationSmartData = filtrationSmartData;
      this.pills = pills !== null && pills !== void 0 ? pills : [];
      this.filtersCategories = filtersCategories;
      this.selectedSectionsCount = selectedSectionsCount > 0 ? selectedSectionsCount : 0;
    }
    catch (error) {
      this.isLoading = false;
      console.error(error);
    }
    finally {
      if (this.isResetFilters) {
        this.isResetFilters = false;
      }
      this.loadProducts(filterUrl);
    }
  }
  loadProducts(filtersUrl) {
    var _a, _b, _c, _d;
    this.isLoading = true;
    const PBSUrl = getPbsFilterProductsUrl({
      host: this.host,
      ProductsPath: (_b = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.productsUrl,
      CheckedFiltersUrl: filtersUrl,
      pbsOffset: this.PBSoffset,
      Nrpp: this.tabs.products.numberProductsOnRangePage,
    });
    const PPWUrl = getFilterProductsUrl((_d = (_c = this.tabs) === null || _c === void 0 ? void 0 : _c.products) === null || _d === void 0 ? void 0 : _d.productsUrl, this.tabs.products.numberProductsOnRangePage, this.localeCode, this.filterNodeId, { pageParam: pageParam.RANGE_LISTING, subCategoryId: '' });
    const url = !this.isPBS ? PPWUrl : PBSUrl;
    getData(false, url)
      .then((response) => {
      this.setProductsInfo(response);
    })
      .finally(() => {
      this.isLoading = false;
      this.isTabsInitialized = true;
    });
  }
  setProductsInfo(productsInfo) {
    if (!productsInfo)
      return;
    const { totalNumRecs, firstRecNum, recsPerPage, productIds, richText } = productsInfo;
    this.richText = parseRichText(richText);
    const productsCount = productIds.length;
    const lastRecNum = firstRecNum + productsCount - 1;
    this.productsCount = productsInfo.totalNumRecs;
    this.resultsCount = {
      firstRecNum,
      lastRecNum,
      recsPerPage,
      totalNumRecs,
    };
    if (!isMobile()) {
      this.firstLoadedRecNum = undefined;
      this.lastLoadedRecNum = undefined;
      this.products = [];
    }
    this.firstLoadedRecNum = this.firstLoadedRecNum === undefined
      ? firstRecNum
      : Math.min(firstRecNum, this.firstLoadedRecNum);
    this.lastLoadedRecNum = this.lastLoadedRecNum === undefined
      ? lastRecNum
      : Math.max(lastRecNum, this.lastLoadedRecNum);
    this.products = productIds;
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23;
    this.host = (_a = tryParse(this._host)) !== null && _a !== void 0 ? _a : this.host;
    this.localeCode = (_b = tryParse(this._localeCode)) !== null && _b !== void 0 ? _b : this.localeCode;
    this.productUrlParams = (_c = tryParse(this._productUrlParams)) !== null && _c !== void 0 ? _c : this.productUrlParams;
    this.endpoint = (_d = tryParse(this._endpoint)) !== null && _d !== void 0 ? _d : this.endpoint;
    this.appProductsLabel = (_e = tryParse(this._appProductsLabel)) !== null && _e !== void 0 ? _e : this.appProductsLabel;
    this.commonFiltersFilterBy = (_f = tryParse(this._commonFiltersFilterBy)) !== null && _f !== void 0 ? _f : this.commonFiltersFilterBy;
    this.facetButtonResetAllLabel = (_g = tryParse(this._facetButtonResetAllLabel)) !== null && _g !== void 0 ? _g : this.facetButtonResetAllLabel;
    this.facetButtonViewLessFilters = (_h = tryParse(this._facetButtonViewLessFilters)) !== null && _h !== void 0 ? _h : this.facetButtonViewLessFilters;
    this.facetButtonViewMoreFilters = (_j = tryParse(this._facetButtonViewMoreFilters)) !== null && _j !== void 0 ? _j : this.facetButtonViewMoreFilters;
    this.nextLabel = (_k = tryParse(this._nextLabel)) !== null && _k !== void 0 ? _k : this.nextLabel;
    this.pageLabel = (_l = tryParse(this._pageLabel)) !== null && _l !== void 0 ? _l : this.pageLabel;
    this.noResultsClearLink = (_m = tryParse(this._noResultsClearLink)) !== null && _m !== void 0 ? _m : this.noResultsClearLink;
    this.noResultsHeader = (_o = tryParse(this._noResultsHeader)) !== null && _o !== void 0 ? _o : this.noResultsHeader;
    this.noResultsMessage = (_p = tryParse(this._noResultsMessage)) !== null && _p !== void 0 ? _p : this.noResultsMessage;
    this.numberProductsOfAllProductsLabel = (_q = tryParse(this._numberProductsOfAllProductsLabel)) !== null && _q !== void 0 ? _q : this.numberProductsOfAllProductsLabel;
    this.previousLabel = (_r = tryParse(this._previousLabel)) !== null && _r !== void 0 ? _r : this.previousLabel;
    this.rangeProductLabel = (_s = tryParse(this._rangeProductLabel)) !== null && _s !== void 0 ? _s : this.rangeProductLabel;
    this.rangeProductsFiltersLabel = (_t = tryParse(this._rangeProductsFiltersLabel)) !== null && _t !== void 0 ? _t : this.rangeProductsFiltersLabel;
    this.viewLessLabel = (_u = tryParse(this._viewLessLabel)) !== null && _u !== void 0 ? _u : this.viewLessLabel;
    this.viewMoreLabel = (_v = tryParse(this._viewMoreLabel)) !== null && _v !== void 0 ? _v : this.viewMoreLabel;
    this.viewProductsLabel = (_w = tryParse(this._viewProductsLabel)) !== null && _w !== void 0 ? _w : this.viewProductsLabel;
    this.rangePresentationLabel = (_x = tryParse(this._rangePresentationLabel)) !== null && _x !== void 0 ? _x : this.rangePresentationLabel;
    this.rangeWebinarsAndResourcesLabel = (_y = tryParse(this._rangeWebinarsAndResourcesLabel)) !== null && _y !== void 0 ? _y : this.rangeWebinarsAndResourcesLabel;
    this.softwareRegistrationLabel = (_z = tryParse(this._softwareRegistrationLabel)) !== null && _z !== void 0 ? _z : this.softwareRegistrationLabel;
    this.rangeSoftwareAndFirmwareLabel = (_0 = tryParse(this._rangeSoftwareAndFirmwareLabel)) !== null && _0 !== void 0 ? _0 : this.rangeSoftwareAndFirmwareLabel;
    this.loadMoreLabel = (_1 = tryParse(this._loadMoreLabel)) !== null && _1 !== void 0 ? _1 : this.loadMoreLabel;
    this.loadPreviousLabel = (_2 = tryParse(this._loadPreviousLabel)) !== null && _2 !== void 0 ? _2 : this.loadPreviousLabel;
    this.descriptionBigger = (_3 = tryParse(this._descriptionBigger)) !== null && _3 !== void 0 ? _3 : this.descriptionBigger;
    this.id = (_4 = tryParse(this._id)) !== null && _4 !== void 0 ? _4 : this.id;
    this.name = (_5 = tryParse(this._name)) !== null && _5 !== void 0 ? _5 : this.name;
    this.navigationState = (_6 = tryParse(this._navigationState)) !== null && _6 !== void 0 ? _6 : this.navigationState;
    this.rangeReference = (_7 = tryParse(this._rangeReference)) !== null && _7 !== void 0 ? _7 : this.rangeReference;
    this.showDocuments = (_8 = tryParse(this._showDocuments)) !== null && _8 !== void 0 ? _8 : this.showDocuments;
    this.tabs = (_9 = tryParse(this._tabs)) !== null && _9 !== void 0 ? _9 : this.tabs;
    this.enableCommerceConnector = (_10 = tryParse(this._enableCommerceConnector)) !== null && _10 !== void 0 ? _10 : this.enableCommerceConnector;
    this.showBuyOnline = (_11 = tryParse(this._showBuyOnline)) !== null && _11 !== void 0 ? _11 : this.showBuyOnline;
    this.currentReference = (_12 = tryParse(this._currentReference)) !== null && _12 !== void 0 ? _12 : this.currentReference;
    this.backLabel = (_13 = tryParse(this._backLabel)) !== null && _13 !== void 0 ? _13 : this.backLabel;
    if (!this.currentReference) {
      this.currentReference = this.isPBS
        ? this.rangeReference
        : getCurrentReference(Boolean((_16 = (_15 = (_14 = this.tabs) === null || _14 === void 0 ? void 0 : _14.products) === null || _15 === void 0 ? void 0 : _15.nodes) === null || _16 === void 0 ? void 0 : _16.length), rangeBasePath);
    }
    this.currentNode = calculateCurrentNodeParams({
      nodeReference: this.rangeReference,
      id: 'root',
      name: this.name,
      nodes: (_17 = this.tabs) === null || _17 === void 0 ? void 0 : _17.products.nodes,
    }, join(getLocaleWithV3(this.localeCode, /^[^A-Z]+$/.test(this.localeCode)), 'product-range', this.rangeReference), this.currentReference, this.backLabel);
    const { offset, productsPerPage } = this.getPaginationParamsWithDefaults;
    this.selectedPage = Math.floor(offset / productsPerPage) + 1;
    this.nodeIdFromNode = (_18 = this.currentNode) === null || _18 === void 0 ? void 0 : _18.id;
    const segments = window.location.pathname
      .split('/')
      .filter((pathSegment) => pathSegment !== '');
    const pathname = !this.isPBS ? window.location.pathname : this.currentReference;
    this.initialNodeIds = getRangeNodesIds(pathname, this.rangeReference);
    if (this.currentReference === segments[segments.length - 1] && this.nodeIdFromNode) {
      this.filterNodeId = this.nodeIdFromNode;
    }
    else {
      this.filterNodeId = (_19 = this.initialNodeIds) === null || _19 === void 0 ? void 0 : _19.nodeId;
    }
    if (this.navigationState) {
      this.isMobileCategorySelected = true;
    }
    this.initialNodeId = this.navigationState;
    this.nodeOrSubCatId = getSelectedNodeIdFromUrl(this.initialNodeId);
    this.baseFilterUrl = getBaseUrl((_21 = (_20 = this.tabs) === null || _20 === void 0 ? void 0 : _20.products) === null || _21 === void 0 ? void 0 : _21.filtersUrl, this.localeCode);
    this.initialfilterUrl = this.getInitialFiltersUrl;
    this.selectedFilterUrl = getRangeFilterUrl(this.filterNodeId, (_23 = (_22 = this.tabs) === null || _22 === void 0 ? void 0 : _22.products) === null || _23 === void 0 ? void 0 : _23.filtersUrl, this.localeCode);
    this.loadFilters(this.selectedFilterUrl);
    window.addEventListener('popstate', this.handlePopState);
  }
  disconnectedCallback() {
    window.removeEventListener('popstate', this.handlePopState);
  }
  setActive(changedFilterUrl) {
    this.PBSoffset = 0;
    this.selectedPage = 1;
    this.products = [];
    this.selectedFilterUrl = changedFilterUrl;
    this.loadFilters(changedFilterUrl);
  }
  render() {
    const tabs = this.getTabs().filter(Boolean);
    return this.isTabsInitialized && h("pes-tabs", { class: "range-tabs", tabs: tabs });
  }
  get el() { return getElement(this); }
};
RangeTabs.style = pesSprykerRangeTabsCss;

export { RangeTabs as pes_spryker_range_tabs };
